import Link from 'next/link'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`
export const TitleContainer = styled.div`
  max-width: 1224px;

  padding: 0 27px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`
export const OverflowContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  margin: 0 auto;
  padding: 0 24px; /* so the last tile can breath */

  & > a {
    flex-shrink: 0;
  }

  & > a:not(:last-child) {
    margin-right: 24px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`
export const RegionImage = styled.div`
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 500px;
  border-radius: 20px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    height: 220px;
  }
`
export const Tile = styled(Link)<{ fullWidth?: boolean }>`
  color: var(--brand-secondary);
  text-decoration: none;
  display: block;
  ${({ fullWidth }) =>
    !fullWidth &&
    `
    width: 390px;
    
    ${RegionImage} {
      width: 390px;
    }

    @media (max-width: 768px) {
      width: 180px;
      
      ${RegionImage} {
        width: 180px;
      }
    }
  `}
`
export const SwiperButtons = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;

  .swiper-button-disabled::before {
    border-color: #cccccc;
  }

  @media (max-width: 720px) {
    display: none;
  }
`

export const SwiperLeft = styled.div`
  width: 40px;
  height: 40px;
  display: block;
  position: relative;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:before {
    content: '';
    display: block;
    width: 30%;
    height: 30%;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(-45deg);
    border-top: 2px solid var(--brand-secondary);
    border-left: 2px solid var(--brand-secondary);
  }
`
export const SwiperRight = styled.div`
  width: 40px;
  height: 40px;
  display: block;
  position: relative;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:before {
    content: '';
    display: block;
    width: 30%;
    height: 30%;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
    border-top: 2px solid var(--brand-secondary);
    border-right: 2px solid var(--brand-secondary);
  }
`

export const SwiperHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
`

export const FullWidthSwiper = styled.div`
  width: 106vw;
  position: relative;

  .swiper {
    padding-left: 25px;
    padding-right: 25px;
  }
  .fw-swiper-tile {
    width: 20vw;
  }

  @media (max-width: 1690px) {
    .fw-swiper-tile {
      width: 25vw;
    }
  }

  @media (max-width: 1480px) {
    .fw-swiper-tile {
      width: 30vw;
    }
  }

  @media (max-width: 1250px) {
    .fw-swiper-tile {
      width: 35vw;
    }
  }

  @media (max-width: 1060px) {
    .fw-swiper-tile {
      width: 40vw;
    }
  }

  @media (max-width: 950px) {
    .fw-swiper-tile {
      width: 45vw;
    }
  }

  @media (max-width: 720px) {
    width: 100vw;
    overflow: hidden;
    left: 0;

    .fw-swiper-tile {
      width: 40vw;
    }

    .swiper {
      padding-left: 25px;
      padding-right: 25px;
    }
  }
`

export const DesktopContainedSwiper = styled.div`
  display: block;

  .swiper-pagination-bullet-active {
    background: var(--brand-secondary);
  }

  .swiper {
    padding-bottom: 30px;
  }

  .swiper-pagination {
    left: 50%;
    transform: translateX(-50%);
  }

  ${SwiperButtons} {
    width: 170px;
    margin: 0 auto;
    z-index: 2;
    position: relative;
    margin-top: -35px;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 15px);
    left: -25px;
    overflow: hidden;
    position: relative;

    .swiper-slide {
      width: 40vw;
    }

    .swiper {
      padding: 0 25px;
    }

    .swiper-pagination {
      display: none;
    }
  }
`

export const ProductListCarousel = styled.div`
  display: block;
  width: 100%;

  @media (max-width: 768px) {
    width: calc(100vw - 15px);
    left: -25px;
    overflow: hidden;
    position: relative;

    .swiper-slide {
      width: 40vw;
    }

    .swiper {
      padding: 0 25px;
    }

    .swiper-pagination {
      display: none;
    }
  }
`

export const SwiperPaginationElement = styled.div`
  justify-content: center;
  margin-top: 15px;
  display: flex;
  --swiper-pagination-color: var(--brand-secondary);
`
